import React, { useCallback, useState } from 'react'
import GridButton from '../../common/components/GridButton'
import { CheckCircle, Clipboard } from 'react-feather'

const ShareButton: React.FC = () => {
  const [isCopied, setIsCopied] = useState<boolean>(false)
  const handleShareButton = useCallback(() => {
    setIsCopied(true)
    navigator.clipboard.writeText(window.location.href)
    setTimeout(() => {
      setIsCopied(false)
    }, 2000)
  }, [])

  return (
    <>
      {!isCopied
        ? <GridButton
          Icon={Clipboard}
          onClick={handleShareButton}
          buttonText="Copy Link"
        />
        : <GridButton
          Icon={CheckCircle}
          onClick={handleShareButton}
          buttonText="Link Copied"
        />
      }
    </>
  )
}

export default ShareButton